"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VersionSelect = void 0;

var _style = require("./style");

var _jsxRuntime = require("react/jsx-runtime");

var VersionSelect = function VersionSelect(_ref) {
  var id = _ref.id,
      selectedVersions = _ref.selectedVersions,
      onChange = _ref.onChange,
      label = _ref.label,
      _ref$versions = _ref.versions,
      versions = _ref$versions === void 0 ? [] : _ref$versions;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.VrsnSelect, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: id,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("select", {
      id: id,
      name: id,
      value: selectedVersions[id],
      onChange: onChange,
      children: versions.map(function (item, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("option", {
          value: item.version,
          children: ["Version ", item.version]
        }, "".concat(id, "-").concat(index));
      })
    })]
  });
};

exports.VersionSelect = VersionSelect;